import React from "react";

interface ArabicSectionProps {
    botIconSrc: string;
    isImageRightSide?: boolean;
    heading?: string;
    point1?: string;
    point2?: string;
    point3?: string;
}

const ArabicSection: React.FC<ArabicSectionProps> = (props) => {
    const {
        botIconSrc,
        isImageRightSide,
        heading = " عزز الثقة وقم بزيادة الإيرادات من خلال المحادثات المدعومة بالذكاء",
        point1 = "احصل على مساعدة الخبراء من الذكاء الاصطناعي الذي يمكن الاعتماد عليه",
        point2 = "رد على العملاء بلغتهم الأم",
        point3 = "قم بتقسيم المصطلحات الفنية إلى رسائل بسيطة",
    } = props;

    return isImageRightSide ? (
        <header className="lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl">
            <header className=" lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl ">
                <div className="flex flex-col lg:flex-row justify-center md:justify-between">
                    <div className="lg:w-1/2 gap-1 flex flex-col my-10 order-1">
                        <span className=" max-w-lg lg:text-left mt-4 text-right">
                            <h2 className="lg:text-4xl lg:px-0 px-4 lg:leading-tight leading-normal text-3xl font-bold text-right">{heading}</h2>
                            <div className="lg:text-lg text-md font-normal space-y-4 pt-5 text-right">
                                <div className="flex items-center justify-end">
                                    <div>{point1}</div>
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-end">
                                    <div>{point2}</div>
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-end">
                                    <div>{point3}</div>
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                            </div>
                        </span>
                        <div className="flex flex-col pt-4 lg:pt-0 md:flex-row gap-4 justify-center md:justify-start mx-12 md:mx-0"></div>
                    </div>

                    <div className="lg:w-1/2 h-full w-full pt-10 lg:pt-10 order-2">
                        <img loading="lazy" src={botIconSrc} alt="bot icon" />
                    </div>
                </div>
            </header>
        </header>
    ) : (
        <header className="lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl">
            <header className=" lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl ">
                <div className="flex flex-col lg:flex-row justify-center md:justify-between gap-4 ">
                    <div className="lg:w-1/2 gap-1 flex flex-col my-10 order-2">
                        <span className=" max-w-lg lg:text-left mt-4 text-right">
                            <h2 className="lg:text-4xl lg:px-0 px-4 lg:leading-tight leading-normal text-3xl font-bold text-right">{heading}</h2>
                            <div className="lg:text-lg text-md font-normal space-y-4 pt-5 text-right">
                                <div className="flex items-center justify-end">
                                    {point1}
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-end">
                                    {point2}
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-end">
                                    {point3}
                                    <div className="mr-2 w-6 h-6 pl-2">
                                        <img
                                            loading="lazy"
                                            src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                            alt="Green Checkmark"
                                            className="w-full h-full"
                                        />
                                    </div>
                                </div>
                            </div>
                        </span>
                        <div className="flex flex-col pt-4 lg:pt-0 md:flex-row gap-4 justify-center md:justify-start mx-12 md:mx-0"></div>
                    </div>

                    <div className="lg:w-1/2 h-full w-full pt-10 lg:pt-10 order-1">
                        <img loading="lazy" src={botIconSrc} alt="bot icon" />
                    </div>
                </div>
            </header>
        </header>
    );
};

export default ArabicSection;
